import React from 'react';

const LimitReachedModal = ({ onClose }) => {
  const handleContactSupport = () => {
    window.location.href = 'mailto:info@anivance.io?subject=Business Card Scanner - Request for More Scans';
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>掃描次數已達上限</h2>
        <div className="limit-message">
          <p>您的免費掃描配額（10次）已用完。</p>
          <p>如需繼續使用，請聯繫我們升級您的帳戶。</p>
        </div>
        
        <div className="contact-info">
          <div className="info-item">
            <span className="icon">📧</span>
            <span>info@anivance.io</span>
          </div>
        </div>

        <div className="modal-actions">
          <button onClick={onClose} className="btn-secondary">
            返回
          </button>
          <button onClick={handleContactSupport} className="btn-primary">
            聯繫我們
          </button>
        </div>
      </div>

      <style jsx="true">{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.7);
          backdrop-filter: blur(5px);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 2000;
          padding: 20px;
        }

        .modal-content {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 24px;
          border: 1px solid rgba(255, 255, 255, 0.6);
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
          max-width: 500px;
          width: 100%;
          padding: 40px;
          text-align: center;
        }

        .modal-content h2 {
          color: rgba(108, 99, 143, 0.9);
          font-size: 28px;
          font-weight: 600;
          margin-bottom: 24px;
          background: linear-gradient(135deg, #3f51b5, #673ab7);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .limit-message {
          margin-bottom: 30px;
        }

        .limit-message p {
          color: rgba(108, 99, 143, 0.8);
          font-size: 16px;
          line-height: 1.6;
          margin: 12px 0;
        }

        .contact-info {
          background: rgba(255, 255, 255, 0.3);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.4);
          border-radius: 16px;
          padding: 20px;
          margin: 30px 0;
        }

        .info-item {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          color: rgba(108, 99, 143, 0.9);
          font-size: 18px;
          font-weight: 500;
        }

        .icon {
          font-size: 24px;
        }

        .modal-actions {
          display: flex;
          gap: 16px;
          justify-content: center;
          margin-top: 30px;
        }

        .btn-primary, .btn-secondary {
          padding: 14px 32px;
          border-radius: 25px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          border: none;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .btn-primary {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
        }

        .btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(102, 126, 234, 0.5);
        }

        .btn-secondary {
          background: rgba(255, 255, 255, 0.3);
          backdrop-filter: blur(10px);
          color: rgba(108, 99, 143, 0.9);
          border: 1px solid rgba(255, 255, 255, 0.4);
        }

        .btn-secondary:hover {
          background: rgba(255, 255, 255, 0.4);
          transform: translateY(-1px);
        }

        @media (max-width: 768px) {
          .modal-content {
            padding: 30px 20px;
          }

          .modal-content h2 {
            font-size: 24px;
          }

          .modal-actions {
            flex-direction: column;
            width: 100%;
          }

          .btn-primary, .btn-secondary {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default LimitReachedModal;